import { Container } from '@mui/material';
import { useEffect, useState } from 'react';

interface HtmlScreenLoaderProps {
  filename: string;
}

const HtmlScreenLoader: React.FC<HtmlScreenLoaderProps> = ({ filename }) => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch(`/${filename}`)
      .then((response) => response.text())
      .then((data) => setHtmlContent(data))
      .catch((error) => console.error('Error loading HTML file:', error));
  }, [filename]);

  return (
    <Container sx={(theme) => ({ maxWidth: 900, [theme.breakpoints.up('lg')]: { width: 900 } })}>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Container>
  );
};

export default HtmlScreenLoader;
